import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Haendler } from '../haendler';
import { UntypedFormControl } from '@angular/forms';
import { HaendlerUebersichtComponent } from '../haendler-uebersicht/haendler-uebersicht.component';
import { StammdatenService } from '../../stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-haendler-verwaltung',
    templateUrl: './haendler-verwaltung.component.html',
    styleUrls: ['./haendler-verwaltung.component.scss'],
})
export class HaendlerVerwaltungComponent implements OnInit, OnDestroy {
    alleHaendlerSubscription: Subscription;
    alleHaendler: Haendler[] = [];
    haendlerCtrls: UntypedFormControl[] = [];

    @ViewChild('favoriten')
    favoritenList: HaendlerUebersichtComponent;

    constructor(
        private readonly stammdatenService: StammdatenService,
        private readonly messageService: MessageService,
    ) {}

    ngOnDestroy(): void {
        this.alleHaendlerSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.ladeAlleHaendler();
    }

    ladeAlleHaendler(): void {
        this.alleHaendlerSubscription?.unsubscribe();
        this.alleHaendlerSubscription = this.stammdatenService.loadHaendler().subscribe({
            next: data => {
                console.debug(data);
                this.alleHaendler = data.records;
                this.initHaendlerCtrls();
            },
            error: (err: any) => {
                this.messageService.errorMessage('Fehler beim Laden aller Haendler', err);
            },
        });
    }

    initHaendlerCtrls() {
        this.haendlerCtrls = [];
        this.alleHaendler.forEach(haendler => {
            this.haendlerCtrls[haendler.viehhaendler_id] = new UntypedFormControl(!!haendler.favorit);
        });
    }
}
